// ParallaxCallSection.js

import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * UIKit Parallax horizontal image with call to action
 * @param {*} props 
 * @returns 
 */
function ParallaxCallSection(props) {
    
    var { t } = useTranslation();

    return (
        <div
            className={`${props.isTopElement ? '' : 'uk-margin-large-top '}uk-height-large uk-background-cover uk-light uk-text-center`}
            data-uk-parallax="bgy: -200"
            style={{ backgroundImage: `url('${props.URL}')` }}
        >
            <div className="uk-container">
                {/* The H2 is gotta be the props.headline */}
                <h2 className="uk-heading-medium uk-margin-large-top">{props.headline}</h2>
                {/* The H2 is gotta be the props.callToAction */}
                <p className="uk-text-lead">{props.callToAction}</p>
                <a href="/apply-visa" className="uk-button uk-button-jai uk-border uk-button-large uk-margin-top">
                    {t("ui.button.business_action.msg")}
                </a>
            </div>
        </div>
    );
}

export default ParallaxCallSection;